export { stripHtmlFromPlainText } from './cv-validation.ts';
